<template>
  <div class="date_select flex items-center justify-between">
    <div
      v-for="(item, index) in dateList"
      :key="index"
      class="list_item items-center"
      :class="{ 'list_item-active': index === currentItem }"
      @click="handleSelect(item, index)"
    >
      <div v-if="index !== 5" class="name">{{ item.name }}</div>
      <div v-else class="ml-15px">
        <el-date-picker
          v-model="formData.date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </div>
    </div>
    <el-button type="primary" @click="onExport">导出</el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentItem: 0,
      dateList: [
        {
          name: '全部',
          days: 0
        },
        {
          name: '今天',
          days: 1
        },
        {
          name: '昨天',
          days: 2
        },
        {
          name: '近7天',
          days: 7
        },
        {
          name: '近30天',
          days: 30
        },
        {
          name: '日期选择'
        }
      ],
      formData: {
        beginTime: '',
        endTime: '',
        date: []
      }
    }
  },
  watch: {
    'formData.date': {
      handler(val) {
        if (val.length) {
          console.log('val--------- :>> ', val)
          const params = {
            beginTime: val.at(0),
            endTime: val.at(1)
          }
          this.$emit('on-date', params)
        }
      },
      deep: true
    }
  },
  methods: {
    handleSelect(item, index) {
      if (index === 5) {
        this.currentItem = null
        return
      }
      this.formData.date = []
      this.currentItem = index
      this.getDays(item.days)
    },
    // 获取天数
    getDays(dayCount = 0) {
      const dayMillionSeconds = 24 * 60 * 60 * 1000 // 一天的毫秒数
      const dayArray = [] // 存储最近日期的数组
      const today = new Date() // 获取当前日期

      // 循环day次，从今天开始依次减去一天的毫秒数，计算出最近day天的日期
      for (let i = 0; i < dayCount; i += 1) {
        const date = new Date(today.getTime() - i * dayMillionSeconds)
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const day = date.getDate()
        // eslint-disable-next-line prefer-template
        const dateString = `${year}-${month < 10 ? '0' + month : month}-${
          // eslint-disable-next-line prefer-template
          day < 10 ? '0' + day : day
        }` // 格式化日期字符串
        dayArray.push(dateString)
      }
      // 全部
      if (dayCount === 0) {
        this.formData.beginTime = ''
        this.formData.endTime = ''
      } else if (dayCount === 1) {
        this.formData.beginTime = dayArray.at(0)
        this.formData.endTime = dayArray.at(0)
      } else if (dayCount === 2) {
        this.formData.beginTime = dayArray.at(-1)
        this.formData.endTime = dayArray.at(-1)
      } else {
        this.formData.beginTime = dayArray.at(-1)
        this.formData.endTime = dayArray.at(0)
      }
      const params = {
        beginTime: this.formData.beginTime,
        endTime: this.formData.endTime
      }
      this.$emit('on-date', params)
      console.log('日期 :>> ', params)
    },
    onExport() {
      this.$emit('on-export')
    }
  }
}
</script>

<style lang="scss" scoped>
.date_select {
  width: 100%;
  display: flex;
  flex: 1;
  .list_item {
    cursor: pointer;

    .name {
      padding: 8px 15px;
      white-space: nowrap;
    }
  }
  .list_item-active {
    border: solid 1px #409eff;
    color: #409eff;
  }
}
</style>
